import React, { forwardRef, useRef } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";
import Select from "react-select";

const AutoDropDown = forwardRef((props, ref) => {
  const isSelectingRef = useRef(false); // ✅ track selection

  const defaultOption = {
    value: "",
    label: props.placeholder || "Select an option",
  };

  // Include default option unless classStar is true
  const optionsWithDefault = props.classStar
    ? props.options
    : [defaultOption, ...props.options];

  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: props.disabled ? "#f9fafb" : provided.backgroundColor, // bg-gray-50
      cursor: props.disabled ? "not-allowed" : "default",
      borderColor: state.isFocused ? "#2563eb" : "#d1d5db", // Tailwind blue-600 focus
      boxShadow: state.isFocused ? "0 0 0 1px #2563eb" : "none",
      minHeight: "2.5rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: props.disabled ? "#9ca3af" : "#111827", // gray-400 if disabled
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: props.disabled ? "#9ca3af" : "#6b7280", // gray-400 or gray-500
      padding: "0 0.25rem",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <div className={props?.classDiv ? props?.classDiv : "form-group"}>
      <label
        className={props?.ClassLabel ? props?.ClassLabel : mainTable.label}
      >
        {props?.title}
        {props?.classStar && <span className={props?.classStar}>*</span>}
      </label>

      <Select
        ref={ref}
        name={props?.name}
        value={props?.selectedOption || defaultOption}
        // onChange={props.controlFunc}
        // onBlur={props.controlFuncBlur}
        onChange={(value, actionMeta) => {
          isSelectingRef.current = true; // ✅ mark selecting

          props.controlFunc && props.controlFunc(value, actionMeta);

          // ✅ clear error properly using parent setter
          if (props.setError) {
            props.setError((prev) => ({
              ...prev,
              [`${props.name}Error`]: value?.value ? "" : "Select",
            }));
          }

          // // ✅ clear error immediately
          // if (props?.controlFuncBlur) {
          //   props.controlFuncBlur(value); // pass value optionally
          // }

          // setTimeout(() => {
          //   isSelectingRef.current = false;
          // }, 150);
          // allow blur after small delay
          setTimeout(() => {
            isSelectingRef.current = false;

            // manually trigger blur logic AFTER state update
            // props.controlFuncBlur && props.controlFuncBlur();
          }, 150);
          //   if (isSelectingRef.current) return;

          // props?.controlFuncBlur && props?.controlFuncBlur();
        }}
        onBlur={(e) => {
          // ✅ prevent blur validation during selection
          if (isSelectingRef.current) return;

          if (props.setError) {
    props.setError((prev) => ({
      ...prev,
      [`${props.name}Error`]: props.selectedOption?.value
        ? ""
        : "Select",
    }));
  }

          props?.controlFuncBlur && props?.controlFuncBlur(e);
        }}
        isDisabled={props.disabled}
        placeholder={props.placeholder}
        tabIndex={props.tabIndex}
        options={optionsWithDefault}
        menuPortalTarget={props.menuPortalTarget}
        menuPlacement="auto"
        menuPosition="fixed"
        styles={customStyles} // Apply custom styling
      />

      {props?.errorMessage && (
        <span className="text-red-500 text-sm font-medium">
          {props?.errorMessage}
        </span>
      )}
    </div>
  );
});

AutoDropDown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  controlFunc: PropTypes.func,
  controlFuncBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  errorMessage: PropTypes.string,
  menuPortalTarget: PropTypes.any,
  classStar: PropTypes.string,
  classDiv: PropTypes.string,
  ClassLabel: PropTypes.string,
  setError: PropTypes.func,
};

export default AutoDropDown;

// import React, { forwardRef, useRef } from "react";
// import PropTypes from "prop-types";
// import { mainTable } from "../css/Common";
// import Select from "react-select";

// const AutoDropDown = forwardRef((props, ref) => {
//   const isSelectingRef = useRef(false); // ✅ track selection

//   const defaultOption = {
//     value: "",
//     label: props.placeholder || "Select an option",
//   };

//   // Include default option unless classStar is true
//   const optionsWithDefault = props.classStar
//     ? props.options
//     : [defaultOption, ...props.options];

//   // Custom styles for react-select
//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       backgroundColor: props.disabled ? "#f9fafb" : provided.backgroundColor, // bg-gray-50
//       cursor: props.disabled ? "not-allowed" : "default",
//       borderColor: state.isFocused ? "#2563eb" : "#d1d5db", // Tailwind blue-600 focus
//       boxShadow: state.isFocused ? "0 0 0 1px #2563eb" : "none",
//       minHeight: "2.5rem",
//     }),
//     singleValue: (provided) => ({
//       ...provided,
//       color: props.disabled ? "#9ca3af" : "#111827", // gray-400 if disabled
//     }),
//     dropdownIndicator: (provided) => ({
//       ...provided,
//       color: props.disabled ? "#9ca3af" : "#6b7280", // gray-400 or gray-500
//       padding: "0 0.25rem",
//     }),
//     placeholder: (provided) => ({
//       ...provided,
//       color: "#9ca3af",
//     }),
//     menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   return (
//     <div className={props.classDiv ? props.classDiv : "form-group"}>
//       <label className={props.ClassLabel ? props.ClassLabel : mainTable.label}>
//         {props.title}
//         {props.classStar && <span className={props.classStar}>*</span>}
//       </label>

//       <Select
//         ref={ref}
//         name={props.name}
//         value={props.selectedOption || defaultOption}
//         onChange={props.controlFunc}
//         onBlur={props.controlFuncBlur}
//         isDisabled={props.disabled}
//         placeholder={props.placeholder}
//         tabIndex={props.tabIndex}
//         options={optionsWithDefault}
//         menuPortalTarget={props.menuPortalTarget}
//         menuPlacement="auto"
//         menuPosition="fixed"
//         styles={customStyles} // Apply custom styling
//       />

//       {props.errorMessage && (
//         <span className="text-red-500 text-sm font-medium">{props.errorMessage}</span>
//       )}
//     </div>
//   );
// });

// AutoDropDown.propTypes = {
//   name: PropTypes.string.isRequired,
//   options: PropTypes.arrayOf(
//     PropTypes.shape({
//       value: PropTypes.string,
//       label: PropTypes.string,
//     })
//   ).isRequired,
//   selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
//   controlFunc: PropTypes.func,
//   controlFuncBlur: PropTypes.func,
//   placeholder: PropTypes.string,
//   disabled: PropTypes.bool,
//   tabIndex: PropTypes.string,
//   errorMessage: PropTypes.string,
//   menuPortalTarget: PropTypes.any,
//   classStar: PropTypes.string,
//   classDiv: PropTypes.string,
//   ClassLabel: PropTypes.string,
// };

// export default AutoDropDown;

// import React from "react";
// import PropTypes from "prop-types";
// import { mainTable } from "../css/Common";
// import Select from "react-select";

// const AutoDropDown = (props) => (
//   <div className={props.classDiv ? props.classDiv : "form-group"}>
//     <label className={props.ClassLabel ? props.ClassLabel : mainTable.label}>
//       {props.title}
//     </label>
//     <Select
//       name={props.name}
//       value={props.value} // Use the value prop for the selected value
//       onChange={props.controlFunc}
//       className={props.Class ? props.Class : mainTable.input}
//       disabled={props.disabled}
//       tabIndex={props.tabIndex}
//       options={props.options}
//     >
//       <option value="">{props.placeholder}</option>
//       {props.options.map((opt) => (
//         <option key={opt.value} value={opt.value}>
//           {opt.label}
//         </option>
//       ))}
//     </Select>
//   </div>
// );

// AutoDropDown.propTypes = {
//   name: PropTypes.string.isRequired,
//   options: PropTypes.arrayOf(
//     PropTypes.shape({
//       value: PropTypes.string.isRequired,
//       label: PropTypes.string.isRequired,
//     })
//   ).isRequired,
//   value: PropTypes.string, // New prop for setting the selected value
//   controlFunc: PropTypes.func.isRequired,
//   placeholder: PropTypes.string,
//   disabled: PropTypes.oneOf(["true", "false"]).isRequired,
//   tabIndex: PropTypes.string.isRequired,
// };

// export default AutoDropDown;
